module.exports = __webpack_public_path__ + "img/avatar6.be6f2073.png";